import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import AthleteCard from "../components/AthleteCard";
import { Search } from "lucide-react";

export default function Golfers() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [country, setCountry] = useState("");
  const [tour, setTour] = useState("");
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const params = {};
      if (q) params.q = q;
      if (country) params.country = country;
      if (tour) params.tour_level = tour;
      const { data } = await api.get("/athletes", { params });
      setItems(data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  return (
    <div className="py-16 md:py-24" data-testid="athletes-page">
      <div className="container-tight">
        <div className="overline">Browse the fund</div>
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl mt-3 tracking-tight leading-[1.02]">
          Every golfer <span className="text-primary">has a story</span>.
        </h1>
        <p className="mt-6 max-w-2xl text-foreground/70">
          Discover verified emerging golfers from amateur, college and developmental tour ranks. Filter by country, tour
          level or simply by name.
        </p>

        {/* Filters */}
        <div className="mt-10 grid grid-cols-1 md:grid-cols-12 gap-3 border border-border" data-testid="athletes-filters">
          <div className="md:col-span-5 flex items-center gap-2 px-4 border-r border-border">
            <Search size={16} className="text-foreground/50" />
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && load()}
              placeholder="Search by golfer name"
              className="w-full h-12 bg-transparent outline-none text-sm"
              data-testid="athletes-search"
            />
          </div>
          <select
            value={country}
            onChange={(e) => setCountry(e.target.value)}
            className="md:col-span-3 h-12 px-4 bg-transparent border-r border-border outline-none text-sm"
            data-testid="athletes-country"
          >
            <option value="">All countries</option>
            <option value="Ireland">Ireland</option>
            <option value="United Kingdom">United Kingdom</option>
          </select>
          <select
            value={tour}
            onChange={(e) => setTour(e.target.value)}
            className="md:col-span-2 h-12 px-4 bg-transparent border-r border-border outline-none text-sm"
            data-testid="athletes-tour"
          >
            <option value="">All levels</option>
            <option value="Amateur">Amateur</option>
            <option value="Amateur Elite">Amateur Elite</option>
            <option value="Amateur / Junior">Amateur / Junior</option>
            <option value="College / D1">College / D1</option>
            <option value="Pro / LET Access">Pro / LET Access</option>
            <option value="Pro / Challenge Tour">Pro / Challenge Tour</option>
          </select>
          <button onClick={load} className="md:col-span-2 bg-primary text-primary-foreground h-12 text-sm font-medium tracking-wide hover:bg-primary/90" data-testid="athletes-apply-filters">
            Apply filters
          </button>
        </div>

        {/* Results */}
        <div className="mt-12">
          {loading ? (
            <div className="overline">Loading…</div>
          ) : items.length === 0 ? (
            <div className="py-24 text-center text-foreground/60" data-testid="athletes-empty">No athletes match your filters.</div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8" data-testid="athletes-grid">
              {items.map((a, i) => <AthleteCard key={a.athlete_id} athlete={a} index={i} />)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
